export enum WccAccountTypes {
  WccProviderAdmin = 'WCC Provider Admin',
  WccClinician = 'WCC'
}
